import { useEffect } from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import styles from './filterpill.module.css'

const FilterPill = ({
    filteredData,
    isFiltered,
    onRemovePill,
    setClearBtn,
    handlefilteredData,
    filteredLabel = {},
    nonRemovablePills,
}) => {
    // List of non-removable pill keys (date filters)
   const DEFAULT_NON_REMOVABLE = [
        'startevent_dt',
        'endevent_dt',
        'id',
        'time_spent_s',
        'status'
    ];

    // When nonRemovablePills is explicitly provided (even as empty array), use it;
    // otherwise fall back to the default list. This allows pages to pass [] to
    // indicate that all form-sourced filter chips should be removable (show ✕).
    const NON_REMOVABLE_PILLS = nonRemovablePills !== undefined
        ? nonRemovablePills
        : DEFAULT_NON_REMOVABLE;
    
    const handleRemovePill = (keyName) => {
        // Don't allow removal of date pills
        if (NON_REMOVABLE_PILLS.includes(keyName)) {
            return;
        }

        if (onRemovePill) {
            onRemovePill(keyName);
        } else {
            const updatedData = { ...filteredData };
            delete updatedData[keyName];
            
            if (Object.keys(updatedData)?.length) {
                setClearBtn(true);
            } else {
                setClearBtn(false);
            }
            handlefilteredData(updatedData);
        }
    }

    useEffect(() => {
        if (isFiltered) {
            handlefilteredData(null);
            setClearBtn(false);
        }
    }, [handlefilteredData, isFiltered, setClearBtn]);

    let filteredPills;
    if (filteredData) {
        filteredPills = Object.keys(filteredData)
            ?.filter(
                (keyName) =>
                    filteredData[keyName] !== undefined &&
                    filteredData[keyName] !== '' &&
                    filteredData[keyName] !== 'true' &&
                    !keyName.endsWith('_exit')
            )
            ?.map((keyName, index) => (
                <li
                    key={index}
                    className={`position-relative rounded py-2 px-2 ${styles.pillItem} ${
                        NON_REMOVABLE_PILLS.includes(keyName) ? styles.nonRemovable : ''
                    }`}
                >
                    <span className="fw-bold">
    {(typeof filteredLabel?.[keyName] === 'object'
        ? filteredLabel[keyName].label
        : filteredLabel?.[keyName]) || keyName}:{' '}
</span>

<span className={styles.pillValue}>
    {typeof filteredLabel?.[keyName] === 'object' && typeof filteredLabel[keyName].format === 'function'
        ? filteredLabel[keyName].format(filteredData[keyName])
        : filteredData[keyName]}
</span>
                    {!NON_REMOVABLE_PILLS.includes(keyName) && (
                        <span
                            role="button"
                            onClick={() => handleRemovePill(keyName)}
                            className={`position-absolute rounded-circle d-flex align-items-center justify-content-center ${styles.iconWrapper}`}
                            aria-label={`Remove ${filteredLabel?.[keyName] || keyName} filter`}
                        >
                            <AiOutlineClose size={9} />
                        </span>
                    )}
                </li>
            ))
    }

    return <ul className={`${styles.pillsList}`}>{filteredPills}</ul>
}

export default FilterPill